export default class User {
  constructor(id, name, password) {
    this.name = name;
    this.id = id;
    this.password = password;
  }
}
